module.exports = __webpack_public_path__ + "assets/img/icon-4.a9e06007.png";